














































































import store from '@store/index';
import { NavigationDataStore } from '@store/modules/navigation';
import {
    useVueRouter,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    defineComponent,
    ref,
} from '@vue/composition-api';
import SdsGlobalHeaderLink from './SdsGlobalHeaderLink.vue';
import SdsGlobalHeaderProductSwitcher from './SdsGlobalHeaderProductSwitcher.vue';
import {
    ContextNavigationItem,
    NavigationContext,
} from '@superbet-group/web.types';
import HeaderNavigationSkeleton from './skeletons/HeaderNavigationSkeleton.vue';
import ProductSwitcherSkeleton from './skeletons/ProductSwitcherSkeleton.vue';
import { getterFromPath } from '@modules/layout/utils/storeGetter';
import { featureFlagService } from '@superbet-group/web.lib.flags';
import {
    setLiteMode,
    getLiteMode,
} from '@modules/layout/header/utils/metaWhitelist';
import { currentSite } from '@src/app/utils/domainHelpers';

export default defineComponent({
    emits: ['pageClick'],
    setup() {
        const { route } = useVueRouter();
        const navigationModule = useVuexStore<NavigationDataStore>('navigation');
        if (route.value?.query?.lite) {
            // Temp meta whitelist
            setLiteMode();
        }

        const currentNavigationContext = navigationModule.getter('currentNavigationContext');
        const topLevelNavigations = navigationModule.getter('topLevelNavigations');

        function isPrimaryNavigation(key: NavigationContext): boolean {
            return key === NavigationContext.Sports;
        }

        const showLiveCasinoInHeader = ref(false);
        featureFlagService.subscribeToFeatureChanges('web.show-live-casino-in-header', (isEnabled) => {
            showLiveCasinoInHeader.value = isEnabled;
        }, false);

        function getOtherNavigations(currentNavigation: string) {
            return Object.keys(topLevelNavigations.value)
                .filter((key) => key !== currentNavigation)
                .flatMap((key) => {
                    const topLevelNavigation = topLevelNavigations.value[key as NavigationContext];
                    if (!topLevelNavigation?.contextSwitcher) {
                        return [];
                    }
                    const productSwitcherItems = [];
                    productSwitcherItems.push({
                        key,
                        destination: topLevelNavigation?.contextSwitcher.destination,
                        label: topLevelNavigation?.contextSwitcher.label,
                        icon: topLevelNavigation?.contextSwitcher.icon,
                        itemClasses: topLevelNavigation?.contextSwitcher?.itemClasses,
                    });
                    if (showLiveCasinoInHeader.value) {
                        topLevelNavigation?.contextSwitcher.children.forEach((navigationChild) => {
                            productSwitcherItems.push({
                                key: navigationChild.label,
                                label: navigationChild.label,
                                icon: navigationChild.icon,
                                destination: navigationChild.destination,
                                itemClasses: navigationChild.itemClasses,
                            });
                        });
                    }
                    return productSwitcherItems;
                });
        }

        const areOtherNavigationsLoaded = computed(() => Object.keys(topLevelNavigations.value).length > 0);

        function prepareNavItems(items: ContextNavigationItem[]) {
            return [...items]
                .filter((item) => {
                    if ((item as any).hideOnSites) {
                        return !(item as any).hideOnSites.includes(currentSite);
                    }
                    return true;
                })
                .sort((a, b) => a.order - b.order)
                .map((item) => {
                    return {
                        ...item,
                        isActive: item.isActive ? item.isActive(route.value) : false,
                        badge: getterFromPath(item.badgeStoreGetter, store),
                    };
                });
        }

        const navigations = computed(() => {
            return Object.keys(topLevelNavigations.value).map((contextKey) => {
                const navigationContext = contextKey as NavigationContext;
                const topLevelNavigation = topLevelNavigations.value[navigationContext]!;
                return {
                    ...topLevelNavigation,
                    key: navigationContext,
                    active: navigationContext === currentNavigationContext.value,
                    primary: isPrimaryNavigation(navigationContext),
                    secondary: !isPrimaryNavigation(navigationContext),
                    desktopItems: prepareNavItems(topLevelNavigation.desktopItems),
                    otherNavigations: getOtherNavigations(navigationContext),
                };
            });
        });

        return {
            navigations,
            isNeutralRoute: computed(() => route.value.meta?.navigationContext === NavigationContext.Neutral),
            hiddenKeys: getLiteMode() ? ['Casino', 'casino live'] : undefined, // Temp query param to exclude casino
            areOtherNavigationsLoaded,

            getOtherNavigations,
            isPrimaryNavigation,
            prepareNavItems,
        };
    },
    components: {
        SdsGlobalHeaderLink,
        SdsGlobalHeaderProductSwitcher,
        HeaderNavigationSkeleton,
        ProductSwitcherSkeleton,
    },
});
